import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg } from 'src/components/svg/SvgStyles';

export default function TextListSvg({ className }: StandardSvgProps) {
	return <SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.593 9.7089993">
		<rect width="13.593"
			height="1.942"
			rx="0.97100002"
			id="rect2"
			x="0"
			y="0" />
		<rect width="13.593"
			height="1.942"
			rx="0.97100002"
			id="rect4"
			x="0"
			y="3.8829999" />
		<rect width="13.593"
			height="1.942"
			rx="0.97100002"
			id="rect6"
			x="0"
			y="7.7670002" />
	</SDefaultSvg>;
}